// simple assert without nested check
function assert(condition, message) {
  if (!condition) {
    throw message;
  }
}

export { assert };
//# sourceMappingURL=assert.esm.js.map
